module.exports = __webpack_public_path__ + "static/media/LcsTop-bg001.66360c7c.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/LcsTop-bg001.png
// module id = 1709
// module chunks = 0 1